module.exports = __webpack_public_path__ + "static/media/sell_rent_6a.45452dc3.png";